import { State } from "../state";
import { AssetState } from "./state";
import { getStoreAccessors } from "typesafe-vuex";
import { Asset } from "@/interfaces/assets";

export const mutations = {
  setAssets(state: AssetState, assets: Asset[]): void {
    state.assets = assets;
  },
};

/* eslint-disable @typescript-eslint/no-explicit-any */
const { commit } = getStoreAccessors<AssetState | any, State>("");

export const commitSetAssets = commit(mutations.setAssets);
